module.exports = __webpack_public_path__ + "img/bg3.ed003616.png";